import * as React from "react"
import {useStaticQuery, graphql} from 'gatsby'
import { getImage,GatsbyImage } from 'gatsby-plugin-image'
import CorporateHeader from '../../components/corporateHeader'
import CorporateFooter from '../../components/corporateFooter'
import {fontFaceMoontime,bgStyleGray,fontColorBlue,fontColorDark,centeredText} from '../../components/shared.module.scss'
import McKinleyNewsBlock from '../../components/mckNews'

const NewsPage = () => {

  const data = useStaticQuery(graphql`
    query {
      contentfulBasicPage(pageTitle: {eq: "McKinley News"}) {
        id
        pageTitle
        pageContent {
          pageContent
        }
        pageImage {
          gatsbyImageData
        }
      }
    }
    `
  )

  const bgimage = getImage(data.contentfulBasicPage.pageImage.gatsbyImageData)
  return (
        <main>
            <CorporateHeader />
            <div style={{background:'url('+bgimage.images.fallback.src+')',
                minHeight:'300px',
                backgroundAttachment:'fixed',
                backgroundSize:'cover',
                backgroundRepeat:'no-repeat',
                backgroundPosition:'center -300px'}}></div>
            <div className="container">
                <div className="columns is-padded">
                    <McKinleyNewsBlock />
                </div>
            </div>
                        <br />
                        <br />
            <CorporateFooter />
        </main>
  )
}

export default NewsPage

export const Head = () => {
  return <>
    <title>McKinley News</title>
    <meta name="description" content="McKinley provides news related to our apartment communities in Florida and Michigan." />
  </>
}
